import { Box, Link, Paper, Typography } from '@mui/material';
import iconSvgLocalPath from '../assets/health-log-b_logomark.svg';

interface BaseCommentProps {
  isRead: boolean;
}

type CommentText = BaseCommentProps & {
  message: string;
};

export const Comment = (props: CommentText) => {
  return (
    <Box sx={{ margin: 'auto', px: 2, py: 1 }}>
      <Box sx={{ margin: 'auto' }} className="flex items-end">
        <MyIcon />
        <Paper square elevation={0} className="border border-primary rounded-tl-md rounded-tr-md rounded-br-md p-2">
          <Typography className="text-sm" sx={{ whiteSpace: 'pre-line', margin: 0 }}>
            {props.message}
          </Typography>
        </Paper>
      </Box>
      <ReadFlgText isRead={props.isRead} />
    </Box>
  );
};

type PDFCommentData = BaseCommentProps & {
  PDFUrl?: (string | null)[] | null;
  PDFTitle?: string | null;
  PDFSize?: string | null;
};

export const PDFComment = (props: PDFCommentData) => {
  const linkPDFUrl = props.PDFUrl?.[0] || undefined;

  return (
    <Box sx={{ margin: 'auto', px: 2, py: 1 }}>
      <Box sx={{ margin: 'auto' }} className="flex items-end">
        <MyIcon />
        <Paper
          square
          elevation={0}
          className="border border-primary rounded-tl-md rounded-tr-md rounded-br-md p-2 w-full"
        >
          <Box className="flex items-center space-x-1">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-6 w-6">
              <title>file-pdf-box</title>
              <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9.5 11.5C9.5 12.3 8.8 13 8 13H7V15H5.5V9H8C8.8 9 9.5 9.7 9.5 10.5V11.5M14.5 13.5C14.5 14.3 13.8 15 13 15H10.5V9H13C13.8 9 14.5 9.7 14.5 10.5V13.5M18.5 10.5H17V11.5H18.5V13H17V15H15.5V9H18.5V10.5M12 10.5H13V13.5H12V10.5M7 10.5H8V11.5H7V10.5Z" />
            </svg>
            <Box>
              {linkPDFUrl ? (
                <Link href={linkPDFUrl} className="text-sm font-bold" color="inherit" download>
                  {props.PDFTitle || 'PDFファイル'}
                </Link>
              ) : (
                <Typography className="text-sm font-bold">PDFファイルが見つかりません</Typography>
              )}
            </Box>
          </Box>
          {props.PDFSize && (
            <Box className="flex items-center space-x-1">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-6 w-6 invisible">
                <title>file-pdf-box</title>
                <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9.5 11.5C9.5 12.3 8.8 13 8 13H7V15H5.5V9H8C8.8 9 9.5 9.7 9.5 10.5V11.5M14.5 13.5C14.5 14.3 13.8 15 13 15H10.5V9H13C13.8 9 14.5 9.7 14.5 10.5V13.5M18.5 10.5H17V11.5H18.5V13H17V15H15.5V9H18.5V10.5M12 10.5H13V13.5H12V10.5M7 10.5H8V11.5H7V10.5Z" />
              </svg>
              <Typography className="text-xs">サイズ：{props.PDFSize}MB</Typography>
            </Box>
          )}
        </Paper>
      </Box>
      <ReadFlgText isRead={props.isRead} />
    </Box>
  );
};

type URLCommentText = BaseCommentProps & {
  url?: (string | null)[] | null;
  urlTitle?: string | null;
};

export const URLComment = (props: URLCommentText) => {
  const linkUrl = props.url?.[0] || undefined;

  return (
    <Box sx={{ margin: 'auto', px: 2, py: 1 }}>
      <Box sx={{ margin: 'auto' }} className="flex items-end">
        <MyIcon />
        <Paper square elevation={0} className="border border-primary rounded-tl-md rounded-tr-md rounded-br-md p-2">
          <Typography className="text-sm">以下のリンクを送信します。</Typography>
          <br />
          {linkUrl ? (
            <Link href={linkUrl} className="text-sm">
              {props.urlTitle || 'リンク'}
            </Link>
          ) : (
            <Typography className="text-sm">リンクがありません</Typography>
          )}
          <br />
        </Paper>
      </Box>
      <ReadFlgText isRead={props.isRead} />
    </Box>
  );
};

const MyIcon = () => {
  return <img src={iconSvgLocalPath} alt="Icon svg" className="w-9 h-9 ml-1 mr-2" />;
};

const ReadFlgText = ({ isRead }: { isRead: boolean }) => {
  return (
    <Box sx={{ margin: 'auto' }} className="text-right pt-1">
      <Typography className={`text-xs text-primary ${isRead ? '' : 'invisible'}`}>既読</Typography>
    </Box>
  );
};
